module.exports = __webpack_public_path__ + "static/CaseStudy_UpNorth-c3cd56ef18f81b52d1f37dd8616499ce.pdf";